import { type LaunchDarklyFlags } from '@/common/launchDarkly';
import { useAccountsApiDs3AccessQuery } from './use-accounts-api-ds3-access-query';
import { useTrialBanner } from './use-trial-banner';

/**
 * A hook to aggregate & return the user's trial and subscription information
 */
export function useDS3Access(flags: LaunchDarklyFlags) {
  const ds3AccessQuery = useAccountsApiDs3AccessQuery({ enabled: flags?.['subscription-required'] !== false });

  const { hasDs3Access, trial, isTrialExpired } = ds3AccessQuery.data ?? {};
  const isPendingAccessCheck = ds3AccessQuery.isLoading || ds3AccessQuery.isError || !ds3AccessQuery.data;

  const {
    showTrialBanner,
    dismissTrialBanner,
    daysLeft,
    showCancelledBanner,
    dismissCancelledBanner,
    isActiveCancelledSubscription,
  } = useTrialBanner({
    trialEndDate: trial?.endDate,
    hasDs3Access,
    isPendingAccessCheck,
  });

  return {
    trial,
    isLoading: flags?.['subscription-required'] === false ? false : isPendingAccessCheck,
    isTrialExpired,
    daysLeft,
    showTrialBanner: flags?.['subscription-required'] === false ? false : showTrialBanner,
    dismissTrialBanner,
    showCancelledBanner: flags?.['subscription-required'] === false ? false : showCancelledBanner,
    dismissCancelledBanner,
    isActiveCancelledSubscription,
    /** Derived by if any of the folllowing are true:
     * The subscription-required flag is disabled
     * They're a standalone user with a Forms subscription
     * They have 'ds3.* in their permissions array */
    hasDs3Access: flags?.['subscription-required'] === false ? true : hasDs3Access,
    isEligibleForExtension: isTrialExpired && !trial?.extensions?.length,
    latestTrialExtension: trial?.extensions?.[0],
  };
}
